export const COLLABORATION_CARET_LABEL_CLASS = 'collaboration-caret__label';
export const COLLABORATION_CARET_CLASS = 'collaboration-caret__caret';
const COLLABORATION_CARET_LABEL_SELECTOR = `.${COLLABORATION_CARET_LABEL_CLASS}`;
function isElementWithClass(node, className) {
    return node instanceof Element && node.classList.contains(className);
}
function nodeContainsCollaborationCaretLabel(node) {
    if (isElementWithClass(node, COLLABORATION_CARET_LABEL_CLASS)) {
        return true;
    }
    return node instanceof Element && node.querySelector(COLLABORATION_CARET_LABEL_SELECTOR) !== null;
}
export function mutationsAffectCollaborationCaretLabels(mutations) {
    for (let i = 0; i < mutations.length; i += 1) {
        const mutation = mutations[i];
        if (mutation.type === 'attributes') {
            if (isElementWithClass(mutation.target, COLLABORATION_CARET_LABEL_CLASS)
                || isElementWithClass(mutation.target, COLLABORATION_CARET_CLASS)) {
                return true;
            }
            continue;
        }
        for (let j = 0; j < mutation.addedNodes.length; j += 1) {
            if (nodeContainsCollaborationCaretLabel(mutation.addedNodes[j])) {
                return true;
            }
        }
    }
    return false;
}
//# sourceMappingURL=collaboration-caret-label-mutations.js.map